import Auth from '@aws-amplify/auth';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { call, put, takeEvery } from 'redux-saga/effects';

import { Actions as AuthActions } from './../ducks/actions';
import { Types as AuthTypes } from './../ducks/types';

function* amplifySignedIn() {
  const cognitoUser: CognitoUser = yield call([Auth, 'currentAuthenticatedUser'], {
    bypassCache: true,
  });
  const userAttributes = yield call(getUserAttributes, cognitoUser);
  const preferredMfaMethod = yield call([Auth, 'getPreferredMFA'], cognitoUser);

  const user = {
    email: userAttributes.email || '',
    name: userAttributes.name || '',
    phoneNumber: userAttributes.phone_number,
    profileImageURL: userAttributes.profile_image_url || '', // this could need changing depending on the attribute name
    preferredMfaMethod,
    sub: userAttributes.sub || '',
  };

  yield put(AuthActions.populateUser(user));
}

function getUserAttributes(cognitoUser: CognitoUser): Promise<{ [key: string]: string }> {
  return new Promise((resolve, reject) => {
    cognitoUser.getUserAttributes((err, result) => {
      if (!!err) {
        return reject(err);
      }

      const attributes = result.reduce((prev, curr) => {
        prev[curr.getName()] = curr.getValue();
        return prev;
      }, {});

      return resolve(attributes);
    });
  });
}

export function* watchForAmplifySignIn() {
  yield takeEvery(AuthTypes.AMPLIFY_SIGNED_IN, amplifySignedIn);
}
